import { useEffect } from 'react'
import { useZustandStore } from 'zustandGlobalStore'
import { useZustandSessionStore } from 'zustandGlobalSessionStore'

export const useInitialSetSearchParamsToSessionStore = (): void => {
  const isFirebaseConfigLoaded = useZustandStore(
    (state) => state.firebaseRemoteConfig,
  )

  useEffect(() => {
    if (isFirebaseConfigLoaded) {
      const searchParams = new URLSearchParams(document.location.search)
      const isWebAppRedirect = searchParams.get('webapp_redirect') === 'true'
      const isPrintablePdf = searchParams.get('printable_pdf') === 'true'

      useZustandSessionStore.setState({ isWebAppRedirect, isPrintablePdf })
    }
  }, [isFirebaseConfigLoaded])
}
